import { Directive, TemplateRef } from '@angular/core';

@Directive({
    // tslint:disable-next-line:directive-selector
    selector: '[formFieldsSelectTrigger]',
    standalone: false
})
export class FormFieldsSelectTriggerDirective {
    constructor(public template: TemplateRef<any>) { }
}
